import { createRouter } from '@tanstack/react-router'
import { scrollAppShellToTop } from '@trellis/roots/navigation'

import { RouteErrorFallback, RouteNotFoundFallback } from '@/components/router'
import { resolveRoutePattern, trackPageView } from '@/lib/analytics'
import { applyDocumentTitle } from '@/lib/page-titles'
import { queryClient } from '@/lib/query-client'

import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreloadStaleTime: 0,
  defaultPreload: 'intent',
  defaultErrorComponent: RouteErrorFallback,
  defaultNotFoundComponent: RouteNotFoundFallback,
})

// Only on a path change: search-param navigations (filters, tabs, pagination) keep their place.
router.subscribe('onRendered', ({ pathChanged }) => {
  applyDocumentTitle(router.state.matches)
  if (!pathChanged) return
  scrollAppShellToTop()
  trackPageView(resolveRoutePattern(router.state.matches))
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
